import { create } from "zustand";
import { GetStaffParams } from "~/services/operation";

type State = {
  formState: {
    open: boolean;
    staffId?: string;
    viewMode?: boolean;
  };
  filters: GetStaffParams;
};

type Actions = {
  setFilters: (filters: GetStaffParams) => void;
  resetFilters: () => void;
  openStaffModal: (staffId?: string, viewMode?: boolean) => void;
  closeStaffModal: () => void;
};

const initialState: State = {
  formState: {
    open: false,
  },
  filters: {
    page: 1,
    pageSize: 10,
    search: "",
  },
};

export const useStaffStore = create<State & Actions>()((set) => ({
  ...initialState,
  setFilters: (filters: GetStaffParams) => {
    set((state) => ({
      filters: {
        ...state.filters,
        ...filters,
      },
    }));
  },
  resetFilters: () => set({ filters: initialState.filters }),
  openStaffModal: (staffId, viewMode = false) =>
    set({
      formState: {
        open: true,
        staffId,
        viewMode,
      },
    }),
  closeStaffModal: () =>
    set({
      formState: {
        open: false,
        staffId: undefined,
        viewMode: false,
      },
    }),
}));
